// extracted by mini-css-extract-plugin
export var body = "_kf-0";
export var sectionHeader = "_kf-4";
export var shortcutColumns = "_kf-2";
export var shortcutList = "_kf-1";
export var shortcutSection = "_kf-3";